import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../config'
import { Observable, Subject, BehaviorSubject, of} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RequestsService {
  url = AppConfig.url_backend
  key = AppConfig.hapikey
  public propertiesData = new BehaviorSubject('');
  public data:any = '2';

  constructor(private http: HttpClient) { }

  getPropertiesData(){
    return this.propertiesData.getValue()
  }

  setPropertiesData(info:any){
    this.propertiesData.next(info);
  }
  
  
  getToken() {
    const token = localStorage.getItem('token');
    return token;
  }

  postHS(form: any): any {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken() || '');

    return this.http.post(this.url + "/createHS", form, {headers:headers});
  }


  hs_updateform(form: any,guid:string): any {

    //console.log("FORM ", form);
    let headers = new HttpHeaders().set('Content-Type', 'application/json') 
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    let json_update={
      name:form.name,
      redirect:form.redirect,
      notifyRecipients:form.notifyRecipients,
      inlineMessage: form.inlineMessage,
      formFieldGroups:form.formFieldGroups,
      ocr: form.ocr,
      onboarding: form.onboarding,
      lifeValidation: form.lifeValidation,
      documentValidation: form.documentValidation,

      //Analizar credolab
      analizarCredolab: form.analizarCredolab,
      startCredolab: ( form.analizarCredolab ) ? form.startCredolab : '',
      stopCredolab:  ( form.analizarCredolab ) ? form.stopCredolab : ''
    }
    console.log(json_update);
    return this.http.put(this.url + "/updateform", {data:json_update,guid:guid}, {headers: headers});
  }

  
  submit_form(datos:any,portalid:number,formid:string): any {
    let data={
      data:datos,
      portalid:portalid,
      formid:formid
    }
    return this.http.post(this.url + "/submit", data);
  }

  insertForm(name: string, hs_c, hs_r, jsona,id:number,urlThanks): any {

    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken() || '');

    let data = {
      name_form: name,
      json_hsc: JSON.stringify(hs_c),
      json_hsr: JSON.stringify(hs_r),
      jsona: JSON.stringify(jsona),
      usuario:id,
      urlThanks:urlThanks
    }

    let resp: Observable<any> = this.http.post(this.url + "/form", data , {headers: headers});
    resp.subscribe(
      res => {
        //console.log(res);
        return res;
      },
      err => {
        console.log(err);
        return err;
      }
    )
    return resp;
  }

  updateForm(name: string, hs_c, hs_r, jsona, urlthanks): any {

    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    console.log("UrL",urlthanks)

    let data = {
      name_form: name,
      json_hsc: JSON.stringify(hs_c),
      json_hsr: JSON.stringify(hs_r),
      jsona: JSON.stringify(jsona),
      urlthanks: urlthanks
    }

    let resp: Observable<any> = this.http.put(this.url + "/form", data, {headers:headers});
    resp.subscribe(
      res => {
        console.log(res);
        return res;
      },
      err => {
        console.log(err);
        return err;
      }

    )
    return resp;
  }

  updateFormWithName(newname: string, name: string, hs_c, hs_r, jsona):any{

    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    let data = {
      new_name_form: newname,
      name_form: name,
      json_hsc: JSON.stringify(hs_c),
      json_hsr: JSON.stringify(hs_r),
      jsona: JSON.stringify(jsona)
    }

    let resp: Observable<any> = this.http.put(this.url + "/formv2", data, {headers:headers});
    resp.subscribe(
      res => {
        console.log(res);
        return res;
      },
      err => {
        console.log(err);
        return err;
      }

    )
    return resp;

  }

  hs_deleteform(guid:string, ocr:boolean):any {

    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    let data = {
      guid: guid,
      ocr: ocr
    }
    let resp: Observable<any>  = this.http.put(`${this.url}/deleteformhs`, data, {headers:headers});
    resp.subscribe(
      res=>{
        return res;
      },
      err =>{
        return err;
      }
    )
  }

  deleteForm_bd(id:any):any{
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    let data = {
      formid: id
    }
    return this.http.put(`${this.url}/deleteform`, data, {headers:headers});
  }


  getForms(): any {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    return  this.http.get(this.url + "/forms", {headers:headers});
  }

  getFormbyId(nombre: string): any {
    console.log(nombre);
    return this.http.get(this.url + "/form?nombre="+nombre)
  }


  getCookie(name:any) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  uploadFile(file:any){
    console.log('Archivo', file);
    return this.http.post(`${this.url}/upload`, file);
  }


  //Servicio para obtener todas las propiedades de contacto existentes en portalBI
  getAllProperties(){
    return this.http.get(`${this.url}/forms/properties`)
  }


  //endpoint para obtener las opciones de un select/checkbox en especifico
  getOptionsByProperty(name: string): any{
    return this.http.get(`${this.url}/options/${name}`)
  }

  //endpoint para verificar si es valido el nombre del formulario
  isFormExists(name:string):any {
    return this.http.get(`${this.url}/findform/${name}`)
  }


  // Endpoint para obtener la lista de todos los usuarios

  getAllUsers(){
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
            .set('X-Content-Type-Options', 'nosniff')
            .set('Cross-Origin-Opener-Policy', 'same-origin')
            .set('Access-Control-Allow-Origin', '*')
            .set('auth', this.getToken());

    return this.http.get(`${this.url}/getUsers`, {headers: headers})

  }

  //Endpoint para verificar si el formulario existe pero esta deshabilitado -> estado = 0. si este existe lo eliminamos para poder crearlo nuevamente
  isDisabledForm(nombre : string):any{
    return this.http.post(`${this.url}/exists`, { name : nombre})
  }


}

   
